import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/lib/auth";

const SUPERADMIN_EMAIL = "frednordimmo@gmail.com";

export function useApprovalStatus() {
  const { user } = useAuth();

  const isSuperadmin = user?.email === SUPERADMIN_EMAIL;

  const query = useQuery({
    queryKey: ["approval-status", user?.id],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("users")
        .select("approved_at")
        .eq("id", user!.id)
        .single();

      if (error) throw error;
      return data;
    },
    enabled: !!user && !isSuperadmin,
  });

  if (isSuperadmin) {
    return { isApproved: true, isLoading: false };
  }

  return {
    isApproved: !!(query.data as { approved_at?: string | null } | undefined)?.approved_at,
    isLoading: query.isLoading,
  };
}
